import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { firestorePlugin } from "vuefire";
import store from "./store";

import Toasted from "vue-toasted";

import * as VueGoogleMaps from "vue2-google-maps";
import * as filters from "./filters";
import * as config from "./config";

import { i18n, langSetup } from "./lang";

import VueQuillEditor from "vue-quill-editor";

import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme

import "@/assets/css/main.css";

/* eslint-disable no-new */
Vue.langSetup = Vue.prototype.$langSetup = langSetup;

Vue.config.productionTip = false;

Vue.prototype.$EventBus = new Vue();

Vue.prototype.globalClick = (callback) => {
  window.onclick = (e) => {
    callback(e);
  };
};
// register global utility filters.
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.use(VueQuillEditor /* { default global options } */);
Vue.use(firestorePlugin);
Vue.use(VueGoogleMaps, {
  load: {
    key: config.GOOGLE_MAP_KEY,
    libraries: "places",
  },
  installComponents: true,
});
Vue.use(Toasted, {
  iconPack: "material-icons-outlined",
  position: "bottom-left",
  duration: 8000,
});
Vue.toasted.register(
  "toast_error",
  (payload) => {
    if (!payload.message) {
      return "Oops.. Something Went Wrong..";
    }
    return payload.message;
  },
  {
    icon: "error",
    action: [
      {
        text: "error",
        class: "toast-error",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        },
      },
      {
        icon: "close",
        class: "toast-close",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        },
      },
    ],
  }
);
Vue.toasted.register(
  "toast_success",
  (payload) => {
    if (!payload.message) {
      return "success..";
    }
    return payload.message;
  },
  {
    icon: "check_circle",
    action: [
      {
        text: "success",
        class: "toast-success",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        },
      },
      {
        icon: "close",
        class: "toast-close",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        },
      },
    ],
  }
);
Vue.toasted.register(
  "toast_info",
  (payload) => {
    if (!payload.message) {
      return "info..";
    }
    return payload.message;
  },
  {
    action: {
      icon: "close",
      class: "toast-close",
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      },
    },
  }
);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
